import React, { useEffect, useState } from 'react';

import * as constants from '../utils/constants';
import { capitalizeFirstLetter, checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import history from '../utils/history';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Button from '../components/common/button/Button';
import MenThankYou from '../assets/images/img_thank_you.svg';
import docExample from '../assets/documents.v2/carta_de_respuesta_BBVA.png';
import { useSelector } from 'react-redux';
import Tooltip from '../components/common/tooltip';
import IconInfo from '../assets/icons/ic_info_blue.svg';

const defaultContent = (onClickBBVA, tooltipActive, advisorInfo) => (
  <div className="thanksPage__right pageContainer__right">
    <div className="titleCont">
      <h3 className="heading-2 u-mb-16">
        Hemos recibido tu solicitud.{' '}
        <Tooltip
          title="Importante"
          description={constants.TOOLTIP_MESSAGES.MSG_4}
          active={tooltipActive}
          hidden={!advisorInfo}
        >
          <img src={IconInfo} />
        </Tooltip>
      </h3>
      <p className="u-mb-40">
        En los próximos minutos, te estaremos enviando un correo electrónico
        indicándote el <b>número de siniestro generado.</b>
      </p>
    </div>

    <section className="infoSection u-mb-40">
      <h4 className="infoSection__title">Ten en cuenta lo siguiente:</h4>
      <ul className="infoSection__list">
        <li>
          El plazo máximo de evaluación de un siniestro es de hasta
          <b> 30 días calendario</b>, siguientes a la presentación de la documentación completa,
          la cual está indicada en tu Certificado de Seguro. Sin embargo, haremos todo lo posible
          para responderte antes de ese plazo.
        </li>
        <li>
          Te pedimos estar pendiente a tu correo por si necesitamos cualquier otro documento o información adicional, que se encuentra descrita en tu Certificado de Seguro, en caso las circunstancias específicas lo ameriten.
        </li>
        <li>
          Para consultas sobre el estado de tu solicitud, llámanos al
          <b> (01) 595 9000 opción 3.</b>
        </li>
      </ul>
    </section>

    <Button primary className="btnReturn">
      <a href={constants.LINK_PRODUCTOS_BBVA_TYPE('estandar')}  onClick={onClickBBVA}>
        Volver a BBVA
      </a>
    </Button>
  </div>
);

const otherSinContent = (onClickBBVA, tooltipActive, advisorInfo) => (
  <div className="thanksPage__right pageContainer__right">
    <div className="titleCont">
      <h3 className="heading-2 u-mb-16">
        Hemos recibido tu solicitud.{' '}
        <Tooltip
          title="Importante"
          description={constants.TOOLTIP_MESSAGES.MSG_4}
          active={tooltipActive}
          hidden={!advisorInfo}
        >
          <img src={IconInfo} />
        </Tooltip>
      </h3>
      <p className="u-mb-40">
        En los próximos minutos, te estaremos enviando un correo electrónico
        indicándote el <b>número de siniestro generado.</b>
      </p>
    </div>

    <section className="infoSection u-mb-40">
      <h4 className="infoSection__title">Ten en cuenta lo siguiente:</h4>
      <ul className="infoSection__list">
        <li>
          Ya que seleccionaste la opción "Mi siniestro es otro", necesitaremos
          <b> revisar si está dentro de las coberturas</b> del seguro.
        </li>
        <li>
          El plazo máximo de evaluación de un siniestro es de hasta
          <b> 30 días calendario</b>, siguientes a la presentación de la documentación completa,
          la cual está indicada en tu Certificado de Seguro. Sin embargo, haremos todo lo posible
          para responderte antes de ese plazo.
        </li>
        <li>
          Te pedimos estar pendiente a tu correo por si necesitamos cualquier otro documento o información adicional, que se encuentra descrita en tu Certificado de Seguro, en caso las circunstancias específicas lo ameriten.
        </li>
        <li>
          Para consultas sobre el estado de tu solicitud, llámanos al
          <b> (01) 595 9000 opción 3.</b>
        </li>
      </ul>
    </section>

    <Button primary className="btnReturn">
      <a href={constants.LINK_PRODUCTOS_BBVA_TYPE('otro-siniestro')} onClick={onClickBBVA}>
        Volver a BBVA
      </a>
    </Button>
  </div>
);

const letterContent = (onClickBBVA, tooltipActive, advisorInfo) => (
  <div className="thanksPage__right pageContainer__right">
    <div className="titleCont">
      <h3 className="heading-2 u-mb-16">
        Hemos recibido tu solicitud.{' '}
        <Tooltip
          title="Importante"
          description={constants.TOOLTIP_MESSAGES.MSG_4}
          active={tooltipActive}
          hidden={!advisorInfo}
        >
          <img src={IconInfo} />
        </Tooltip>
      </h3>
      <p className="u-mb-40">
        En los próximos minutos, te estaremos enviando un correo electrónico
        indicándote el <b>número de siniestro generado.</b>
      </p>
    </div>

    <section className="infoSection u-mb-40">
      <h4 className="infoSection__title">Ten en cuenta lo siguiente:</h4>
      <ul className="infoSection__list">
        <li>
          Recuerda que si no adjuntaste la <b>carta emitida por BBVA</b>, donde
          se detalle las operaciones o transacciones no reconocidas, deberás
          ingresar nuevamente al formulario para adjuntarla y completar la
          documentación.
        </li>
        <li>
          El plazo máximo de evaluación de un siniestro es de hasta
          <b> 30 días calendario</b>, siguientes a la presentación de la documentación completa,
          la cual está indicada en tu Certificado de Seguro. Sin embargo, haremos todo lo posible
          para responderte antes de ese plazo.
        </li>
        <li>
          Te pedimos estar pendiente a tu correo por si necesitamos cualquier otro documento o información adicional, que se encuentra descrita en tu Certificado de Seguro, en caso las circunstancias específicas lo ameriten.
        </li>
        <li>
          Para consultas sobre el estado de tu solicitud, llámanos al
          <b> (01) 595 9000 opción 3.</b>
        </li>
      </ul>
    </section>

    <Button primary className="btnReturn">
      <a href={constants.LINK_PRODUCTOS_BBVA_TYPE('carta-banco-pendiente')} onClick={onClickBBVA}>
        Volver a BBVA
      </a>
    </Button>
  </div>
);

const letterSentContent = (onClickBBVA) => (
  <div className="thanksPage__right pageContainer__right">
    <div className="titleCont">
      <h3 className="heading-2 u-mb-16">
        Hemos recibido el documento faltante.
      </h3>
      <p className="u-mb-40">
        En los próximos minutos, te estaremos enviando un correo electrónico de
        confirmación.
      </p>
    </div>

    <section className="infoSection u-mb-40">
      <h4 className="infoSection__title">Ten en cuenta lo siguiente:</h4>
      <ul className="infoSection__list">
        <li>
          La carta emitida por el BBVA que nos enviaste{' '}
          <b>completa la información que necesitamos</b> para atender tu caso.
        </li>
        <li>
          El plazo de evaluación de un siniestro es de
          <b> 30 días calendario</b>, siguientes a la presentación de toda la
          información completa señalada en tu contrato de seguro. Sin embargo,
          haremos todo lo posible para responderte antes de ese plazo.
        </li>
        <li>
          Para consultas sobre el estado de tu solicitud, llámanos al
          <b> (01) 595 9000 opción 3.</b>
        </li>
      </ul>
    </section>

    <Button primary className="btnReturn">
      <a href={constants.LINK_PRODUCTOS_BBVA_TYPE('post-carta-banco')} onClick={onClickBBVA}>
        Volver a BBVA
      </a>
    </Button>
  </div>
);

const alterContent = (onClickBBVA) => (
  <div className="thanksPage__right pageContainer__right">
    <div className="titleCont">
      <h3 className="u-mb-16">Compras vía internet no reconocidas</h3>
    </div>

    <section className="infoSection u-mb-40">
      <p className="u-mb-16">Repórtalo a través de los siguientes canales:</p>
      <ul className="infoSection__list">
        <li>
          Banca por internet.{' '}
          <a
            className="purple"
            href={constants.LINK_BBVA_BANCA}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver aquí
          </a>
        </li>
        <li>
          App BBVA.{' '}
          <a
            className="purple"
            href={constants.LINK_BBVA_BANCA_MOBILE}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver aquí
          </a>
        </li>
        <li>
          Email:{' '}
          <a className="purple" href="mailto: terespondemos@bbva.com">
            terespondemos@bbva.com
          </a>
        </li>
        <li>
          Contact Center: Te puedes comunicar directamente al{' '}
          <b>(01) 595 0000.</b>
        </li>
      </ul>

      <div className="infoSection__text">
        Si ya cuentas con la <b>carta de respuesta</b> del BBVA (ver ejemplo{' '}
        <a
          className="purple"
          href={docExample}
          target="_blank"
          rel="noopener noreferrer"
        >
          aquí
        </a>
        ). Puedes enviar un correo explicando tu caso a{' '}
        <b>siniestrosprotecciondetarjeta@bbva.com</b> con el asunto
        <b>"Compras no reconocidas por internet".</b>
      </div>
    </section>

    <div className="btnContainer">
      <Button secondary className="btnReturn__alter" onClick={history.goBack}>
        Regresar
      </Button>
      <Button primary className="btnReturn u-ml-12">
        <a href={constants.LINK_PRODUCTOS_BBVA} onClick={onClickBBVA}>
          Volver a BBVA
        </a>
      </Button>
    </div>
  </div>
);

const ThankYouPage = ({ location }) => {
  const advisorInfo = useSelector( (state) => state.sinisterCards.advisorInfo)
  const [tooltipActive, setTooltipActive] = useState(true);
  const [viewStartTime] = useState(new Date());
  const params = new URLSearchParams(location.search).get('type');
  const currentCoveragePlan = useSelector(
    (state) => state.coverages.currentPlan
  );

  useEffect(() => {
    setTimeout(() => {
      setTooltipActive(false);
    }, constants.DELAY_OUT_TOOLTIP);
  }, []);

  useEffect(() => {
    if (!viewStartTime) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const endTime = new Date();
    const userTotalTime = timeBetweenDates(viewStartTime, endTime);

    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        task: {
          name: 'Tiempo registrado - Gracias',
          time: userTotalTime,
        },
        event: 'trackTimeToComplete',
      });
    }
  }, [viewStartTime]);

  useEffect(() => {
    if (!currentCoveragePlan || !params) return;
    if (checkIfHotjarEnable()) {

      let tipoAnalitics;
      switch (params) {
        case 'otroSiniestro':
          tipoAnalitics = "new-gracias-otro-siniestro";
          break;
        case 'postCartaBanco':
          tipoAnalitics = "new-gracias-post-carta-banco";
          break;
        case 'pendienteCartaBanco':
          tipoAnalitics = "new-gracias-pendiente-carta-banco";
          break;
        default:
          tipoAnalitics = "new-gracias";
          break;
      }
     
      window.digitalData.push({
        virtual: {
          name: `web:tramites-siniestros:proteccion-tarjeta-${currentCoveragePlan.toLowerCase()}:${tipoAnalitics}`
        },
        event: "trackVirtual"
      });
    }
  }, [currentCoveragePlan, params]);

  const onReturnToBBVA = () => {
    if (checkIfHotjarEnable()) {
      let tipo;
      switch (params) {
        case 'otroSiniestro':
          tipo = "Mi siniestro es otro";
          break;
        case 'postCartaBanco':
          tipo = "Post Carta Banco";
          break;
        case 'pendienteCartaBanco':
          tipo = "Pendiente Carta Banco";
          break;
        default:
          tipo = "";
          break;
      }
      if (currentCoveragePlan) {
        // LAST
        window.digitalData.push({
          "action": {
            "group": "Tramites Siniestros - Protección Tarjeta BBVA",
            "category": `Thank you Page ${tipo} - ${capitalizeFirstLetter(currentCoveragePlan.toLowerCase())}`,
            "name": "Botón",
            "label": "Volver a BBVA"
          },
          "event": 'trackAction'
        });
      }
    }
  };
  const validarContenido = param => {
    switch (param) {
      case 'otroSiniestro':
        return otherSinContent(onReturnToBBVA, tooltipActive, advisorInfo)
      case 'postCartaBanco':
        return letterSentContent(onReturnToBBVA)
      case 'pendienteCartaBanco':
        return letterContent(onReturnToBBVA, tooltipActive, advisorInfo)
      default:
        return defaultContent(onReturnToBBVA, tooltipActive, advisorInfo)
    }
  };

  return (
    <>
      <RimacTopBar />
      <div data-testid="thank-you-page" className="thanksPage pageContainer">
        <div className="thanksPage__left pageContainer__left">
          <div className="titleCont">
            <img className="mascota" src={MenThankYou} alt="rimac mascota" />
          </div>
        </div>

        {
          validarContenido(params)
        }
        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default ThankYouPage;
